// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3Q2Vw","info":"PatientInfo_info__33O-Z"};